export default __webpack_public_path__ + "static/media/mauquenchy3.cf75b656.jpg";